import { DataServiceModule } from '../data/data.service';
import { AppSettingsModule } from '../settings.provider';
import { LaunchDarklyServiceModule } from '../access/launchDarkly/launchDarkly.service';

export const StorefrontCacheServiceModule = angular
    .module('app.services.utilities.storefrontCacheService', [
        AppSettingsModule,
        DataServiceModule,
        LaunchDarklyServiceModule
    ]).factory('storefrontCacheService', (
        settings,
        dataService,
        launchDarklyService
    ) => {
        return {
            refresh
        };

        function refresh(resource) {
            return launchDarklyService.getFeature('remove-theme-versioning')
                .then((getsFeature) => {
                    if (getsFeature) {
                        return dataService.create(settings.api.refreshStorefrontCache, { contents: resource });
                    }
                });
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/utilities/storefrontCache.service.js